
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.76 5.024a4.15 4.15 0 00-2.183.864c-.243.204-.47.428-.677.67a4.543 4.543 0 00-.603 1.039 4.282 4.282 0 00-.265.948L5 8.74v14.45a4.114 4.114 0 003.494 3.76c.292.046.563.051 2.005.048h1.436l-.072-.04c-.658-.38-1.253-1.368-1.593-2.623a12.631 12.631 0 01-.363-2.463c-.014-.162-.019-2.182-.022-7.973V6.132l.083.077c.047.043 2.023 1.999 4.391 4.35l4.336 4.28v2.657l-.231-.231c-.385-.38-5.106-5.076-5.98-5.948l-.796-.797v4.226c0 4.252 0 4.725.048 5.52.106 1.799.358 3.14.778 4.143.111.252.237.498.377.736.245.38.55.718.903 1.002.55.395 1.178.667 1.842.797l.245.056h3.671c4.034 0 3.718 0 4.158-.085a4.14 4.14 0 002.995-2.535c.126-.319.215-.65.266-.99.021-.15.026-.576.029-7.233V8.875a4.122 4.122 0 00-3.77-3.848h-3.181l.082.045c.153.09.293.202.415.332.647.646 1.125 1.775 1.364 3.224.084.528.14 1.06.17 1.594 0 .173.019 2.27.021 7.973v7.707l-.053-.045c-.032-.026-1.497-1.48-3.26-3.229a4107.575 4107.575 0 01-4.336-4.305l-1.134-1.124v-2.706l2.584 2.573 3.512 3.5.93.927v-4.22-4.646c-.08-2.503-.383-4.175-.97-5.355a3.916 3.916 0 00-.73-1.063 3.496 3.496 0 00-1.024-.741 5.307 5.307 0 00-1.232-.42L16.173 5h-3.67c-1.991.005-3.674.005-3.743.024z"}})])
          )
        }
      }
    